import { memo } from 'react'
import IconButton from '../../../Buttons/IconButton'
import BookmarkIcon from '../../../Icons/AddBookmark'
import Container from '../Container'

const BookmarkButton = ({ shadow, title, onClick, size, color, filled }) => {
    return (
        <Container shadow={shadow} title={title}>
            <IconButton onClick={onClick}>
                <BookmarkIcon size={size} color={color} filled={filled} />
            </IconButton>
        </Container>
    )
}

export default memo(BookmarkButton)
